import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BaseApiTemplateService} from "../shared/base-api-template-service.model";
import {Core2Config} from "../shared/core2Config";
import {SchedulerContainerModel} from "../../../../../models/aggregates/sch";
import { ApiVisa } from "../shared/api-visa.model";
import { Observable } from "rxjs";
import { BasicApiResponseModel } from "../shared/api-response.model";

@Injectable({
  providedIn: 'root'
})
export class SchedulerService extends BaseApiTemplateService<SchedulerContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SCH_PREFIX + 'crontabs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SCH_PREFIX + 'crontabs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SCH_PREFIX + 'crontabs';
    this.httpClient = http;
  }

  runNow(schedulerGuid: string, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let dto = {}; 
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/scheduler/execute/backoffice-ep/" + schedulerGuid;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      dto,
      this.getHttpHeader(apiVisa)
    );
  }

}
